<template>
  <div>
    <Transition name="fade">
      <modal-devices v-if="app.state.matches('app.modal.visible.devices')" />
    </Transition>
    <Transition name="fade">
      <modal-permissions v-if="app.state.matches('app.modal.visible.permissions')" />
    </Transition>
    <Transition name="fade">
      <modal-qr v-if="app.state.matches('app.modal.visible.qr')" />
    </Transition>
    <Transition name="fade">
      <slow-network v-if="app.state.matches('app.modal.visible.slowNetwork')" />
    </Transition>
    <Transition name="fade">
      <modal-connections v-if="app.state.matches('app.modal.visible.connections')" />
    </Transition>
    <Transition name="fade">
      <a-loader v-if="app.isLoading" :message="app.loadingMessage" @cancel="loaderCancelHandler" />
    </Transition>
    <Transition name="fade">
      <connection-status v-if="app.state.matches('app.modal.visible.connectionStatus')" />
    </Transition>
    <Transition name="fade">
      <participants v-if="app.state.matches('app.modal.visible.participants')" />
    </Transition>
    <permissions-view v-if="app.state.matches('app.view.permissions')" />
    <join-view v-if="app.state.matches('app.view.join')" />
    <meeting-view v-if="app.state.matches('app.view.meeting')" />
    <exit-view v-if="app.state.matches('app.view.exit')" />
  </div>
</template>
<style lang="scss">
html,
body {
  overscroll-behavior: none;
  -webkit-overflow-behavior: none;
}
</style>
<script setup>
import { watchEffect } from 'vue'
import { useAppStore } from '@/stores'
import { useLanguage } from '@/composables'
import process from 'process'

import {
  BackendNotificationProcedure,
  BoardProcedure,
  ChatProcedure,
  ProfileProcedure,
  StreamProcedure,
  StartSessionProcedure,
  ParticipantDisjoinedProcedure,
  ParticipantDisconnectedProcedure,
  ParticipantMuteProcedure,
  PermissionsProcedure,
  ParticipantReadyProcedure,
  PeerErrorProcedure,
  RoleExchangeProcedure,
  TransformProcedure,
  SnapshotProcedure,
  TorchProcedure,
  ConnectionsProcedure,
  ScreensharingProcedure,
  RecordingProcedure,
  DestroyProcedure,
  DocumentEventProcedure,
  NotificationProcedure,
  SignalProcedure,
  MuteUnmuteProcedure,
  ChangeStrategyProcedure,
  ConnectionFailedProcedure,
  NetworkProcedure,
  LogProcedure,
  VideoHealthCheckProcedure,
  LiveCaptionProcedure,
  ViewportHeightProcedure,
} from './procedures'
import { procedures } from '@communication'
import ConnectionStatus from '@/views/Modals/ConnectionStatus/ConnectionStatus.vue'
import Participants from '@/views/Modals/Participants/Participants.vue'
import { useTranslation } from 'i18next-vue'

const app = useAppStore()

window.process = process

watchEffect(() => {
  document.body.style.backgroundColor = app.state.matches('app.view.meeting') ? '#000' : '#FFF'
})
const { t } = useTranslation()
const setupProcedures = () => {
  procedures.add(new BackendNotificationProcedure())
  procedures.add(new BoardProcedure())
  procedures.add(new ChatProcedure())
  procedures.add(new ConnectionFailedProcedure())
  !!window.localStorage.getItem('airelink:logger') && procedures.add(new ConnectionsProcedure())
  procedures.add(new ParticipantDisjoinedProcedure())
  procedures.add(new StreamProcedure())
  procedures.add(new PermissionsProcedure())
  procedures.add(new ProfileProcedure())
  procedures.add(new ParticipantDisconnectedProcedure())
  procedures.add(new ParticipantMuteProcedure())
  procedures.add(new ParticipantReadyProcedure())
  procedures.add(new PeerErrorProcedure())
  procedures.add(new RecordingProcedure())
  procedures.add(new RoleExchangeProcedure())
  procedures.add(new TransformProcedure())
  procedures.add(new SnapshotProcedure())
  procedures.add(new TorchProcedure())
  procedures.add(new StartSessionProcedure())
  procedures.add(new ScreensharingProcedure())
  procedures.add(new DestroyProcedure())
  procedures.add(new DocumentEventProcedure())
  procedures.add(new NotificationProcedure())
  procedures.add(new SignalProcedure())
  procedures.add(new MuteUnmuteProcedure())
  procedures.add(new ChangeStrategyProcedure())
  procedures.add(new NetworkProcedure())
  procedures.add(new LogProcedure())
  procedures.add(new VideoHealthCheckProcedure())
  procedures.add(new LiveCaptionProcedure(t))
  procedures.add(new ViewportHeightProcedure())
}

const { language, initialize } = useLanguage()
setupProcedures()
initialize(language.value).then(() => {
  app.transition('connected')
  app.transition('app')
})

function loaderCancelHandler() {
  // TODO: is it safe?
  app.loaded()
}
</script>
